import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8.5 13.5h1V8h-1zM9 6.577q.261 0 .438-.177a.6.6 0 0 0 .178-.439.6.6 0 0 0-.178-.438A.6.6 0 0 0 9 5.346a.6.6 0 0 0-.438.177.6.6 0 0 0-.178.439q0 .261.178.438A.6.6 0 0 0 9 6.577M9.003 18a8.8 8.8 0 0 1-3.51-.709 9.1 9.1 0 0 1-2.859-1.923 9.1 9.1 0 0 1-1.925-2.856A8.75 8.75 0 0 1 0 9.003q0-1.866.709-3.51a9.1 9.1 0 0 1 1.923-2.859A9.1 9.1 0 0 1 5.488.709 8.75 8.75 0 0 1 8.997 0q1.866 0 3.51.709a9.1 9.1 0 0 1 2.859 1.922 9.1 9.1 0 0 1 1.925 2.857A8.75 8.75 0 0 1 18 8.997a8.8 8.8 0 0 1-.709 3.51 9.1 9.1 0 0 1-1.923 2.859 9.1 9.1 0 0 1-2.856 1.925A8.75 8.75 0 0 1 9.003 18"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }